export default "__VITE_ASSET__9f51288b__"